import { setFilter } from 'src/redux/slices/eLearning/learningPath/list'

export const handleChangeSearch = (value) => (dispatch) => {
  const payload = { key: 'name', value }
  dispatch(setFilter(payload))
}
